const Layout = () => import('../pages/layout')
const staticRoutes = [{
		path: '/',
		redirect: '/home'
	},
	// 错误页面
	{
		path: '/error',
		component: Layout,
		children: [{
			path: '401',
			component: () => import( /* webpackChunkName: 'error' */ '../pages/error/401')
		}]
	},
	// 登录
	{
		path: '/login',
		component: () => import('../pages/login')
	},
	// 系统数据,echart图标展示等
	{
		path: '/home',
		component: Layout,
		children: [{
			path: '',
			component: () => import( /* webpackChunkName: 'home' */ '../pages/home')
		}]
	},
	// 产品
	{
		path: '/goods',
		component: Layout,
		children: [{
			path: '',
			component: () => import( /* webpackChunkName: 'goods' */ '../pages/goods')
		},
		{
			path: '/goods/goodsDetail',
			component: () => import( /* webpackChunkName: 'goods' */ '../pages/goods/goodsDetail')
		}]
	},
	// 购物车
	{
		path: '/cart',
		component: Layout,
		children: [{
			path: '',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/cart')
		}]
	},
	// 订单
	{
		path: '/order',
		component: Layout,
		children: [{
			path: '',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/order')
		},{
			path: '/order/createOrder',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/order/createOrder')
		},{
			path: '/order/orderPay',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/order/orderPay')
		},{
			path: '/order/wxpay',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/order/wxpay')
		}]
	},
	// 个人中心
	{
		path: '/userManage',
		component: Layout,
		children: [{
			path: '',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/userManage')
		},{
			path: '/userManage/collect',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/userManage/collect')
		},{
			path: '/userManage/couponList',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/userManage/couponList')
		},{
			path: '/userManage/couponCenter',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/userManage/couponCenter')
		},{
			path: '/userManage/addressList',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/userManage/addressList')
		},{
			path: '/userManage/userSetting',
			component: () => import( /* webpackChunkName: 'cart' */ '../pages/userManage/userSetting')
		}]
	},
	// 系统设置
	{
		path: '/setting',
		component: Layout,
		children: [{
			path: '',
			component: () => import( /* webpackChunkName: 'setting' */ '../pages/setting')
		}]
	},
	
]
export default staticRoutes
